import { Link } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import type { Lang } from './LanguageContext';
import { useState } from 'react';

function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <div className="lang-switcher">
      <button
        type="button"
        className="lang-switcher-current"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="true"
        aria-expanded={open}
        aria-label="Change language"
      >
        {lang}
        <span className="lang-switcher-caret" aria-hidden="true">
          <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
            <path
              d="M1 1L4.5 4.5L8 1"
              stroke="currentColor"
              strokeWidth="1.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      {open && (
        <div className="lang-switcher-menu">
          {(['EN', 'PL'] as Lang[]).map((option) => (
            <button
              key={option}
              type="button"
              className="lang-switcher-option"
              onClick={() => {
                setLang(option);
                setOpen(false);
              }}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function SiteNav() {
  const { lang } = useLanguage();
  const t = translations[lang];

  return (
    <nav className="site-nav">
      <Link to="/about" className="site-nav-link">
        {t.nav.about}
      </Link>
      <Link to="/" className="site-nav-link">
        {t.nav.gallery}
      </Link>
      <Link to="/contact" className="site-nav-link">
        {t.nav.contact}
      </Link>
      <LanguageSwitcher />
    </nav>
  );
}